module.exports = __webpack_public_path__ + "img/reading__alligator.ae93480d.svg";